import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { apiRequest } from "@core/services/api/apiRequest";
import { Loader } from "@themes/pollinator/ui/Loader";
import { Type } from "@themes/pollinator/ui/Type";
import { MarketingSection } from "@platform/features/marketing";
import { NewsPost } from "./NewsPost";
import type { NewsPost as NewsPostData } from "../../news.types";

export function NewsPostContainer() {
  const { slug } = useParams<{ slug: string }>();

  const { data: post, isLoading, isError } = useQuery<NewsPostData>({
    queryKey: ["newsPost", slug],
    queryFn: () => apiRequest(`/blog/${slug}/`, "GET", undefined, false),
    enabled: !!slug,
    retry: false,
  });

  if (post) return <NewsPost post={post} />;

  // A draft, an archived post or a bad link all land here, and none of them
  // is worth explaining to a visitor beyond saying it is not there.
  return (
    <MarketingSection id="post" className="border-b border-brand-700">
      {isLoading ? (
        <div className="flex justify-center py-12">
          <Loader />
        </div>
      ) : (
        isError && (
          // The page's heading, since it is the only thing the page says.
          <Type variant="body1" as="h1" className="text-brand-700">
            That post is not available.
          </Type>
        )
      )}
    </MarketingSection>
  );
}

export default NewsPostContainer;
